import React from 'react';
import Joyride from 'react-joyride';

const ActivityHistoryTour = ({ run, onFinish, dontShowAgain, setDontShowAgain }) => {
  const steps = [
    {
      target: '#activity-tabs',
      content: 'Use these tabs to switch between your Research Agent and List Cleaner results.',
      disableBeacon: true,
      placement: 'bottom-start'
    },
    {
      target: '[data-view-results-action="true"]',
      content: 'Click the eye icon to view detailed results for any completed job.',
      placement: 'top',
      spotlightClicks: true
    }
  ];
  
  const handleCallback = (data) => {
    const { status } = data;
    if (status === 'finished' || status === 'skipped') {
      onFinish();
    }
  };
  
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showSkipButton={false}
      disableOverlayClose={true}
      disableCloseOnEsc={true}
      callback={handleCallback}
      tooltipComponent={({ continuous, index, step, backProps, closeProps, primaryProps, skipProps, tooltipProps }) => (
        <div {...tooltipProps} style={{ ...tooltipProps.style, maxWidth: 400 }}>
          <div style={{ padding: '20px', backgroundColor: '#1e2439', borderRadius: '8px' }}>
            {step.title && <h4 style={{ color: '#ffffff', marginBottom: '10px' }}>{step.title}</h4>}
            <div style={{ color: '#ffffff', marginBottom: '20px' }}>{step.content}</div>
            
            {/* Add checkbox for don't show again on the last step */}
            {index === steps.length - 1 && (
              <div style={{ 
                marginBottom: '15px', 
                padding: '10px', 
                backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <input
                  type="checkbox"
                  id="dontShowAgain"
                  checked={dontShowAgain}
                  onChange={(e) => setDontShowAgain(e.target.checked)}
                  style={{ marginRight: '10px', cursor: 'pointer' }}
                />
                <label 
                  htmlFor="dontShowAgain" 
                  style={{ 
                    color: '#ffffff', 
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    margin: 0
                  }}
                >
                  Don't show this tutorial again
                </label>
              </div>
            )}
            
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {index > 0 && (
                <button {...backProps} style={{ 
                  backgroundColor: 'transparent', 
                  color: '#0095FF', 
                  border: '1px solid #0095FF',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>
                  Back
                </button>
              )}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                {continuous && primaryProps && (
                  <button {...primaryProps} style={{ 
                    backgroundColor: '#0095FF', 
                    color: '#ffffff', 
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}>
                    {index === steps.length - 1 ? 'Finish' : 'Next'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      styles={{
        options: {
          primaryColor: '#0095FF',
          backgroundColor: '#1e2439',
          textColor: '#ffffff',
          overlayColor: 'rgba(0, 0, 0, 0.7)'
        },
        overlay: {
          cursor: 'default'
        },
        tooltip: {
          position: 'relative'
        },
        tooltipArrow: {
          left: '100px !important' // Move arrow to the left to align with tabs
        }
      }}
    />
  );
};

export default ActivityHistoryTour;